import { render, staticRenderFns } from "./ManageUrbanismRegulationZonesForm.vue?vue&type=template&id=4a41fa3e&"
import script from "./ManageUrbanismRegulationZonesForm.vue?vue&type=script&lang=js&"
export * from "./ManageUrbanismRegulationZonesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports